export const environment = {
  production: true,
  applicationId: 12,
  backendUrl: 'https://www.solidaria.com.co/WSAPIPatrimoniales',
  validacionExclusion: 'https://www.solidaria.com.co/APIIdentitySyncCheck',
  codigosRamos : [45, 47, 74],
  backendUrlEmision: 'https://www.solidaria.com.co/WSAPIPatrimonialesEmision',
  backendUrlImpresion:'https://www.solidaria.com.co/APIPrintingTemplates',
  puerto: '',
  FechaExpTomadorFieldActivate : false,

  //API Risk Service
  APIRiskBaseUrl : 'https://www.solidaria.com.co/PeopleRiskAPI/',
  APIRiskTokenUrl : 'api/Auth/get-token',
  APIRiskValidateRiskUrl : 'api/Person/ValidateRisk',
  APIRiskUserName : 'CUMPLIPEOPLERISK',
  APIRiskPassword : 'CUMPP30PLER1SK',
  APIRiskIdAplication : 36,
  APIRiskSucursal : 0,
  APIRiskIdMovimiento : 0,
  APIRiskModoValidacion : 1,
  APIRiskPersonType : 7,
  APIRiskMessage : "No se puede crear la persona, comuníquese con la Gerencia Oficial de Cumplimiento",
};
